<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Combined results</h1>
            <p class="lead">View pupil reading test question results combined and over time.</p>
        </div>
    </div>
    <ReportingCombinedResultsComp :classes="classes" />
    <v-overlay :model-value="isLoading.classes" class="align-center justify-center">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

const adminStore = useAdminStore();
adminStore.fetchClasses();

const { classes, isLoading } = storeToRefs(adminStore);

definePage({ meta: { area: 'reporting' } });
</script>
